import _ from 'lodash';

// Normalize a string for fuzzy matching: lowercase + strip punctuation/whitespace.
// "W2", "W-2", "W 2" all collapse to "w2" so they match each other.
// TODO: consume a server-side synonym list once the endpoint is available.
const normalize = str => (str ?? '').toLowerCase().replace(/[\s\W_]+/g, '');

export const compareBySearchValue = (prop, searchValue) => {
  const normalizedProp = normalize(prop);
  const normalizedSearch = normalize(searchValue);

  if (normalizedSearch && normalizedProp.includes(normalizedSearch)) {
    return true;
  }

  return (prop ?? '')?.search(new RegExp(_.escapeRegExp(searchValue), 'gim')) !== -1;
};

const searchItems = mapItemToKeys => (searchValue, items) =>
  items?.filter(item =>
    mapItemToKeys(item).some(prop => compareBySearchValue(prop, searchValue)),
  ) || [];

export default searchItems;
